/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IStockistCheckerData } from './stockist-checker.data';
import { IStockistCheckerProps } from './stockist-checker.props.autogenerated';
import { readAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/CustomersDataActions.g';
export interface IStockistCheckerViewProps extends IStockistCheckerProps<IStockistCheckerData> {
    customers: any;
}
export interface IStockistCheckerState {
    customers: {};
}
/**
 *
 * StockistChecker component
 * @extends {React.PureComponent<IStockistCheckerProps<IStockistCheckerData>>}
 */
class StockistChecker extends React.PureComponent<IStockistCheckerProps<IStockistCheckerData>, IStockistCheckerState> {
    constructor(props: any) {
        super(props);
        this.state = {
            customers: {}
        };
    }
    public async componentDidMount() {
        const customerAccountNumber = this.props.context.actionContext.requestContext.user.customerAccountNumber;
        if (customerAccountNumber) {
            await this.getStockistCustomers(customerAccountNumber);
        }
    }

    private readonly getStockistCustomers = async (customerAccountNumber: any) => {
        //const customerInfo = this.props.data.customerInformation.result;
        if (customerAccountNumber) {
            if (this.props.context.actionContext.requestContext.user.isAuthenticated) {
                const customers: any = await readAsync({ callerContext: this.props.context.actionContext }, customerAccountNumber);
                const attributes = customers ? customers.Attributes : [];
                const stockistAttribute = attributes.find((a: any) => {
                    return this.props.config.stockistAttributeName === a.Name;
                });
                this.setState({ customers: customers });
                console.log('stockistForm Stockist Checker', customers);
                if (
                    !customers ||
                    (customers && customers.Attributes.length === 0) ||
                    (customers.Attributes.length > 0 && stockistAttribute && stockistAttribute.AttributeValue.StringValue === 'None')
                ) {
                    const request = this.props.context.request;
                    window.location.href = `${request.url.requestUrl.origin}${request.sitePath}${this.props.config.redirectStoreSelectorUrl}?redirectUri=${request.url.requestUrl.href}`;
                }
            }
        }
    };
    public render(): JSX.Element | null {
        const viewProps: IStockistCheckerViewProps = {
            ...(this.props as IStockistCheckerProps<IStockistCheckerData>),
            customers: this.state.customers
        };
        return this.props.renderView(viewProps);
    }
}

export default StockistChecker;
